import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransfer3Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.20724 11.7572C8.59776 12.1478 8.59776 12.7809 8.20724 13.1715L6.37881 14.9999H16.0001C16.5524 14.9999 17.0001 15.4476 17.0001 15.9999C17.0001 16.5522 16.5524 16.9999 16.0001 16.9999H6.37881L8.20724 18.8283C8.59776 19.2188 8.59776 19.852 8.20724 20.2425C7.81672 20.6331 7.18355 20.6331 6.79303 20.2425L3.25749 16.707C2.86697 16.3165 2.86697 15.6833 3.25749 15.2928L6.79303 11.7572C7.18355 11.3667 7.81672 11.3667 8.20724 11.7572ZM15.7929 3.75725C16.1535 3.39676 16.7206 3.36903 17.1129 3.67406L17.2071 3.75725L20.7427 7.29278C21.1032 7.65327 21.1309 8.2205 20.8259 8.61279L20.7427 8.707L17.2071 12.2425C16.8166 12.6331 16.1835 12.6331 15.7929 12.2425C15.4324 11.882 15.4047 11.3148 15.7097 10.9225L15.7929 10.8283L17.6214 8.99989H8C7.44772 8.99989 7 8.55217 7 7.99989C7 7.48705 7.38604 7.06438 7.88338 7.00662L8 6.99989H17.6214L15.7929 5.17146C15.4024 4.78094 15.4024 4.14777 15.7929 3.75725Z",
		fill: "currentColor"
	})
});
export default SvgTransfer3Line;
